import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Card, Col, InputGroup, Row, Spinner } from "react-bootstrap";
import { useQuery } from "react-query";
import Select from "react-select";
import Icon from "@mdi/react";
import { mdiBroom, mdiCardRemoveOutline, mdiDomain, mdiFilter, mdiFilterOutline } from "@mdi/js";

import { SelectGroupStartStyle, SelectOptions } from "../../config/select";
import { SkeletonCount } from "../../config/defines";
import { QuestionnaireResponseGetResponse } from "../../entities/QuestionnaireResponseEntity";
import { QuestionnaireGetQuestionnairesResponse } from "../../entities/QuestionnaireEntity";
import QuestionnaireResponseService from "../../services/QuestionnaireResponseService";
import QuestionnaireService from "../../services/QuestionnaireService";
import ClientService from "../../services/ClientService";
import UnitService from "../../services/UnitService";

import EdificacaoCard from "../../components/EdificacaoCard";
import Layout from "../../components/Layout";

export default function Avaliacoes() {
	const questionnaireResponseService = new QuestionnaireResponseService();
	const questionnaireService = new QuestionnaireService();
	const clientService = new ClientService();
	const unitService = new UnitService();

	const navigate = useNavigate();

	const [filtro, setFiltro] = useState(false);
	const [filtroQuestionnaire, setFiltroQuestionnaire] = useState<{ label: string; value: number } | null>();
	const [filtroClient, setFiltroClient] = useState<{ label: string; value: number } | null>();
	const [filtroUnit, setFiltroUnit] = useState<{ label: string; value: number } | null>();
	const [filtroQuery, setFiltroQuery] = useState<{ questionnaireId?: number; clientId?: number; unitId?: number }>();

	const queryQuestionnaires = useQuery<QuestionnaireGetQuestionnairesResponse[]>(["avaliacoes"], () => fetchDataQuestionnaires());
	const queryClientes = useQuery(["clientes"], () => fetchDataClientes());
	const queryUnidades = useQuery(["unidades", filtroClient?.value], () => fetchDataUnidades(filtroClient?.value), { enabled: !!filtroClient?.value });

	const { data, isLoading, isRefetching, isError } = useQuery<QuestionnaireResponseGetResponse[]>(["avaliacoesRespostas", filtroQuery], () => fetchData(filtroQuery));

	useEffect(() => {
		let sessionFiltro = sessionStorage.getItem("avaliacoesFiltro");
		if (sessionFiltro) {
			let sessionFiltroJSON = JSON.parse(sessionFiltro);
			setFiltro(true);
			setFiltroQuestionnaire(sessionFiltroJSON.questionnaire);
			setFiltroClient(sessionFiltroJSON.client);
			setFiltroUnit(sessionFiltroJSON.unit);
			setFiltroQuery(sessionFiltroJSON.query);
		}
	}, []);

	async function fetchData(data: any) {
		const resp = await questionnaireResponseService.getQuestionnaireResponses(data);
		return resp.data;
	}

	async function fetchDataQuestionnaires() {
		const resp = await questionnaireService.getQuestionnaires();
		return resp.data;
	}

	async function fetchDataClientes() {
		let resp = await clientService.getClients();
		return resp.data;
	}

	async function fetchDataUnidades(clientId: any) {
		let resp = await unitService.getUnits(clientId);
		return resp.data;
	}

	function handleFiltro() {
		setFiltro(!filtro);
	}

	function handleLimpar() {
		setFiltroQuestionnaire(null);
		setFiltroClient(null);
		setFiltroUnit(null);
		setFiltroQuery({
			questionnaireId: undefined,
			clientId: undefined,
			unitId: undefined,
		});
		sessionStorage.removeItem("avaliacoesFiltro");
	}

	function handleAplicar() {
		setFiltroQuery({
			questionnaireId: filtroQuestionnaire?.value,
			clientId: filtroClient?.value,
			unitId: filtroUnit?.value,
		});

		let sessionData = {
			questionnaire: filtroQuestionnaire,
			client: filtroClient,
			unit: filtroUnit,
			query: {
				questionnaireId: filtroQuestionnaire?.value,
				clientId: filtroClient?.value,
				unitId: filtroUnit?.value,
			},
		};
		sessionStorage.setItem("avaliacoesFiltro", JSON.stringify(sessionData));
	}

	const filtroQuestionnaireOptions = queryQuestionnaires.data?.map((item) => {
		return { label: `${item.title} #${item.id}`, value: item.id };
	});

	const filtroClientOptions = queryClientes.data?.map((item) => {
		return { label: `${item.name}`, value: item.id };
	});

	const filtroUnitOptions = queryUnidades.data?.map((item) => {
		return { label: `${item.name}`, value: item.id };
	});

	const dataMock = [
		{
			id: 3,
			questionnaireName: "Edifício Blue Tower",
			responseDate: "24/04/2025 07:50:44",
			geoLocation: {
				id: 482,
				latitude: -30.028804907318328,
				longitude: -51.18620722208981,
			},
			person: {
				id: 18,
				name: "Germano",
				email: "Germano@ndt.eng.br",
				cpf: "00000000000",
				phone: "00000000000",
			},
			questionnaireId: 70,
			questionResponses: [],
		},
		{
			id: 2,
			questionnaireName: "Edifício Red Tower",
			responseDate: "15/04/2025 15:15:24",
			geoLocation: {
				id: 480,
				latitude: -30.040785431896854,
				longitude: -51.2314031945011,
			},
			person: {
				id: 18,
				name: "Germano",
				email: "lucas@ndt.eng.br",
				cpf: "00000000000",
				phone: "00000000000",
			},
			questionnaireId: 1,
			questionResponses: [],
		},
		{
			id: 1,
			questionnaireName: "Edifício Green Tower",
			responseDate: "15/04/2025 13:12:49",
			geoLocation: {
				id: 478,
				latitude: -30.02861610467074,
				longitude: -51.185687652713355,
			},
			person: {
				id: 18,
				name: "Germano",
				email: "lucas@ndt.eng.br",
				cpf: "00000000000",
				phone: "00000000000",
			},
			questionnaireId: 1,
			questionResponses: [],
		},
	];

	return (
		<Layout header={{ exibirAplicativos: true }}>
			<h5 className="mt-4 mb-4 d-flex align-items-center fw-light">
				<Icon path={mdiDomain} size={1} className="me-1" /> Edificações
				{isRefetching && <Spinner size="sm" className="ms-1" variant="secondary" />}
				<div className="d-flex gap-2 float-right ms-auto" style={{ marginTop: -10, marginBottom: -10 }}>
					<Button className="shadow-sm rounded-3" variant="light" onClick={handleFiltro}>
						<Icon path={filtro ? mdiFilter : mdiFilterOutline} size={1} />
					</Button>
					<Button
						variant="primary"
						className="rounded-3 shadow-sm"
						onClick={() => {
							navigate(`/edificacaoFormulario`);
						}}
					>
						Cadastrar
					</Button>
				</div>
			</h5>

			{filtro && (
				<Row>
					<Col>
						<Card className="mb-4">
							<Card.Body>
								<Row>
									<Col>
										<Row>
											<Col>
												<InputGroup>
													<InputGroup.Text className="bg-white">Avaliação</InputGroup.Text>
													<Select
														placeholder={"Selecione"}
														value={filtroQuestionnaire}
														options={filtroQuestionnaireOptions}
														onChange={(value) => {
															setFiltroQuestionnaire(value);
														}}
														isClearable={true}
														styles={SelectGroupStartStyle}
														{...SelectOptions}
													/>
												</InputGroup>
											</Col>
											<Col>
												<InputGroup>
													<InputGroup.Text className="bg-white">Cliente</InputGroup.Text>
													<Select
														placeholder={"Selecione"}
														value={filtroClient}
														options={filtroClientOptions}
														onChange={(value) => {
															setFiltroClient(value);
															if (!value) {
																setFiltroUnit(null);
															}
														}}
														isClearable={true}
														styles={SelectGroupStartStyle}
														{...SelectOptions}
													/>
												</InputGroup>
											</Col>
											<Col>
												<InputGroup>
													<InputGroup.Text className="bg-white">Unidade</InputGroup.Text>
													<Select
														placeholder={"Selecione"}
														value={filtroUnit}
														options={filtroUnitOptions}
														onChange={(value) => {
															setFiltroUnit(value);
														}}
														isClearable={true}
														styles={SelectGroupStartStyle}
														{...SelectOptions}
													/>
												</InputGroup>
											</Col>
										</Row>
									</Col>
									<Col sm={12} md="auto" className="d-flex gap-2">
										<Button className="shadow-sm rounded-3" variant="light" onClick={handleLimpar} disabled={isLoading}>
											<Icon path={mdiBroom} size={1} />
										</Button>
										<Button className="shadow-sm rounded-3" variant="primary" onClick={handleAplicar} disabled={isLoading}>
											Aplicar
										</Button>
									</Col>
								</Row>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			)}

			<Row className="mb-4">
				{isLoading &&
					Array.from({ length: Number(SkeletonCount) }, (_, index) => {
						return (
							<Col md={12} key={index}>
								<EdificacaoCard skeleton />
							</Col>
						);
					})}
				{!isLoading && isError && (
					<Col md={12}>
						<Alert variant="secondary" className="text-center">
							Problema na operação. Tente novamente mais tarde
						</Alert>
					</Col>
				)}
				{!isLoading && data && data.length === 0 && (
					<Col md={12}>
						<Alert variant="light" className="text-center p-4 d-flex justify-content-center align-items-center">
							<Icon path={mdiCardRemoveOutline} size={1} className="me-2" />
							Nenhum registro encontrado
						</Alert>
					</Col>
				)}
				{!isLoading &&
					dataMock?.map((item) => {
						return (
							<Col md={12} key={item.id}>
								<EdificacaoCard data={item as any} />
							</Col>
						);
					})}
			</Row>
		</Layout>
	);
}
